<template>
  <div class="login-phone-password-container">
    <div class="content">
      <div class="head">
        <div class="close" @click="$router.back()"></div>
        <div class="title">设置账户密码</div>
      </div>
      <div class="form">
        <Field
          class="input"
          v-model="password"
          type="password"
          placeholder="请输入要设置的密码"
          maxlength="11"
          autofocus
        />
        <Button class="btn" @click="loginHandle" :loading="loading"
          >确认</Button
        >
      </div>
    </div>
    <!-- 详细信息弹窗 -->
		<van-dialog v-model="userInfoShow" title="请完善信息" show-cancel-button :before-close="closeDialog" @confirm="registerCustomer" @cancel="rulesTipHide = true">
      <van-form ref="reference">
				<van-field v-model="userInfo.realName" required label="真实姓名" placeholder="请输入真实姓名" :error-message="userInfo.realName||rulesTipHide?'':'请输入真实姓名'" />
				<van-field v-model="userInfo.wxName" required label="微信名" placeholder="请输入微信名" :error-message="userInfo.wxName||rulesTipHide?'':'请输入微信名'" />
				<van-field v-model="userInfo.birthday" required label="出生年月" readonly placeholder="请选择出生年月" @click="popupShow = true" :error-message="userInfo.birthday||rulesTipHide?'':'请选择出生年月'" />
				<van-field v-model="userInfo.occupation" required label="职业" placeholder="请输入职业" :error-message="userInfo.occupation||rulesTipHide?'':'请输入职业'" />
				<van-field v-model="userInfo.companyName" required label="公司名称" placeholder="请输入公司名称" :error-message="userInfo.companyName||rulesTipHide?'':'请输入公司名称'" />
				<van-field v-model="userInfo.companyAddress" type="textarea" :autosize="{ maxHeight: 80 }" required label="公司地址" placeholder="请输入公司地址" :error-message="userInfo.companyAddress||rulesTipHide?'':'请输入公司地址'" />
				<van-field v-model="userInfo.deliveryAddress" type="textarea" :autosize="{ maxHeight: 80 }" required label="收货地址" placeholder="请输入收货地址" :error-message="userInfo.deliveryAddress||rulesTipHide?'':'请输入收货地址'" />
      </van-form>
		</van-dialog>
		<van-popup v-model="popupShow" position="bottom">
			<van-datetime-picker v-model="pickerValue" type="date" :min-date="minDate"   @confirm="pickerConfirm" @cancel="pickerCancel"/>
		</van-popup>
  </div>
</template>

<script>
import { Field, Toast, Dialog, Button } from "vant";
import { registerCustomer, getBindWechatInfo } from "@/api/login";
import { isWechat } from "@/utils/auth";
import dayjs from "dayjs";

export default {
  components: { Field, Button },
  data() {
    return {
      loading: false,
      password: "",
      phone: this.$route.query.phone,
      type: this.$route.query.type,
      code: this.$route.query.code,
      redirect: undefined,
      otherQuery: {},
      userInfoShow: false,
      popupShow: false,
      userInfo:{
        birthday: null,
        realName: null,
        wxName: null,
        occupation: null,
        companyName: null,
        companyAddress: null,
        deliveryAddress: null,
      },
      pickerValue: dayjs('2000-01-01').$d,
      minDate: dayjs().subtract(100, 'year').$d,
      rulesTipHide: true,
    };
  },
  methods: {
    loginHandle() {

      if (/^[a-zA-Z0-9_-]{6,16}$/.test(this.password)) {
        if (this.$route.query.invitationCode) {
          this.registerStore();
        } else {
          const code_flag = this.code.length === 6 ? true : false;
          if (code_flag) {
            this.userInfoShow = true
            // this.registerCustomer();
          } else {
            if (this.code.length === 12) {
              Toast.fail("验证码超过6位,12 位验证码无效。");
              Toast.fail("正在重新传递二维码");
              const code = this.code.substring(6)
              this.code =  code
              this.userInfoShow = true
              // this.registerCustomer();
            } else {
              Toast.fail("验证码超过6位,12 位验证码无效。");
            }
          }
        }
      } else {
        Toast.fail("请输入至少六位数密码");
      }
    },
    // 设置分销员
    registerStore() {
      this.$router.push({
        name: "RegisterInviteCode",
        query: {
          ...this.$route.query,
          password: this.password,
        },
      });
    },
    // 设置顾客
    registerCustomer() {
      for(let  key  in  this.userInfo) {
        if  (this.userInfo.hasOwnProperty(key) &&  (this.userInfo[key]  ===  ""||  this.userInfo[key]  ===  null)) {
          this.rulesTipHide = false
          return
      }}
      let su = this.$route.query.su
      if (su && Array.isArray(su)) {
          su = su[0]
      }
      const params = {
        code: this.code,
        mobile: this.phone,
        customerId: this.$route.query.customerId,
        password: this.password,
        su: su,
        ...this.userInfo
      };
      this.$store.dispatch("app/showLoading");

      registerCustomer(params)
        .then((res) => {
          console.log("ddd", res.data);
          this.$store.dispatch("user/setLoginInfo", res.data);
          this.$store.dispatch("app/hideLoading");
          this.$store.dispatch("sms/resetCode");
          // Toast.success("注册成功");


          console.log("this.redirect", this.redirect);
          if (this.redirect && this.redirect !== "/") {
            this.$router.push({
              path: this.redirect,
              query: this.otherQuery,
            });
          } else {
            return getBindWechatInfo();
          }
        })
        .then((res) => {

          if (!res) return false;
          if (!isWechat() || res.data) {
            this.$router.push("/");
          } else {
            Dialog.confirm({
              message: `您的手机号还未绑定微信<br/>绑定微信有助您账户安全 请绑定微信`,
              theme: "round-button",
              confirmButtonText: "去绑定",
              cancelButtonText: "取消",
              showCancelButton: true,
              closeOnClickOverlay: true,
              beforeClose: (action, done) => {
                if (action === "confirm") {
                  done();
                  this.$router.push({
                    path: "/mine/setting",
                  });
                } else {
                  done();
                  this.$router.push("/");
                }
              },
            }).catch(() => {});
          }
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
        });
    },

    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
     // 时间处理
    pickerConfirm(value) {
      this.userInfo.birthday = dayjs(value).format('YYYY-MM-DD')
      this.popupShow = false
    },
    pickerCancel() {
      this.pickerValue = dayjs('2000-01-01').$d
      this.popupShow = false
    },
    // 关闭前弹窗回调
    closeDialog(action,done) {
      if (action === 'confirm') {
        for  (let  key  in  this.userInfo) {
          if  (this.userInfo.hasOwnProperty(key) &&  (this.userInfo[key]  ===  ""||  this.userInfo[key]  ===  null)) {
            this.rulesTipHide = false
            done(false)
            return
        }}
      done()
      }else{
        done()
      }
    },
  },

  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.close {
  display: inline-block;
  width: 30px;
  height: 4px;
  background: #333;
  border-radius: 4px;
  transform: rotate(45deg);
  &::after {
    content: "";
    display: block;
    width: 30px;
    height: 4px;
    background: #333;
    border-radius: 4px;
    transform: rotate(-90deg);
  }
}
.login-phone-password-container {
  height: 100vh;
  width: 100vw;
  .content {
    width: 100%;
    padding: 0 40px;
  }
  .head {
    display: flex;
    align-items: center;
    padding: 30px 0;
    .title {
      flex: 1;
      font-size: 28px;
      line-height: 1;
      text-indent: -20px;
    }
  }
  .form {
    padding-top: 136px;
    .input {
      flex: 1;
      padding: 20 0;
      font-size: 36px;
      &::placeholder {
        color: #aeaeae;
      }
    }
    .btn {
      margin-top: 80px;
      width: 100%;
      background: #e82035;
      line-height: 82px;
      border-radius: 50px;
      font-size: 26px;
      text-align: center;
      color: #fff;
    }
  }
  .other {
    text-align: center;
    font-size: 26px;
    line-height: 36px;
    padding-top: 40px;
    span {
      color: #aeaeae;
      & + span {
        margin-left: 80px;
      }
    }
  }
}
</style>
